import { ToolLinks } from "./ToolLinks";
import { policyLinks, site } from "../config/site";

type SiteFooterProps = {
  description?: string;
  locale?: "en" | "es";
  appearance?: "default" | "brand";
};

export function SiteFooter({ description = site.description, locale = "en", appearance = "default" }: SiteFooterProps) {
  const spanish = locale === "es";
  const contents = (
    <>
      <div className="footer-brand">
        {appearance === "brand" ? (
          <a className="footer-wordmark" href={spanish ? "/es/" : "/"}>
            <img src="/favicon-96x96.png" alt="" width={40} height={40} loading="lazy" />
            <span>{site.name}</span>
          </a>
        ) : <strong>{site.name}</strong>}
        <p>{description}</p>
      </div>
      <div className="footer-link-groups">
        <div className="footer-link-group">
          <p className="footer-group-title">{spanish ? "Herramientas" : "Tools"}</p>
          <nav className="footer-links" aria-label={spanish ? "Herramientas" : "Tools"}>
            <ToolLinks locale={locale} />
          </nav>
        </div>
        <div className="footer-link-group">
          <p className="footer-group-title">{spanish ? "Información del sitio" : "Information"}</p>
          <nav className="footer-links" aria-label={spanish ? "Información del sitio (en inglés)" : "Information"}>
            {policyLinks.map((link) => (
              <a key={link.key} href={link.path} hrefLang="en">
                {spanish ? link.spanishLabel : link.label}
                {spanish && <span className="footer-language"> (inglés)</span>}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
  return (
    <footer className="site-footer">
      {appearance === "brand" ? <div className="footer-inner">{contents}</div> : contents}
    </footer>
  );
}
